var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { AccountRecoveryEmailContext } from './AccountRecoveryEmailContext';
// Carries the email between the login and recovery pages without putting it in the URL (WCAG 3.3.7)
export const AccountRecoveryEmailProvider = ({ children, }) => {
    _react_refresh_temp_2();
    const [accountRecoveryEmail, setAccountRecoveryEmail] = useState('');
    const value = useMemo(() => ({ accountRecoveryEmail, setAccountRecoveryEmail }), [accountRecoveryEmail]);
    return (_jsx(AccountRecoveryEmailContext.Provider, { value: value, children: children }));
};
_react_refresh_temp_1 = AccountRecoveryEmailProvider;
$RefreshReg$(_react_refresh_temp_1, "AccountRecoveryEmailProvider");
_react_refresh_temp_2(AccountRecoveryEmailProvider, "EALKY5AQwsuwGy5XYDwFJCoMOuc=");
